export default "__VITE_ASSET__9cd64689__"